<template>
    <div class="Banner">
        <swiper class="swiper" :options="swiperOption">
            <swiper-slide v-for="item in Data" :key="item.id">
                <!-- <img src="../../assets/img/index/banner.jpg" alt=""> -->
                <img :src="$Global.CommImgHttp+item.url" alt="">
            </swiper-slide>
            <div v-if="Data.length>1" class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                Data: "",
                swiperOption: {
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    },
                    // 显示分页
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true 
                    },
                }
            }
        },
        mounted() {
            this.GetData()
        },
        methods: {
            GetData() {
                this.$get("api/index/getBanner").then(res => {
                    if(res.data.code == 1){
                        this.Data = res.data.data;
                    }
                    
                })
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
        },
    }
</script>
<style>
    .swiper-pagination-bullet {  
      width: 8px;              /* 自定义宽度 */  
      height: 5px;             /* 自定义高度 */  
      background-color: #fff;   /* 自定义背景颜色 */  
      opacity: 1;               /* 自定义透明度 */  
      border-radius: 3px;       /* 自定义圆角 */  
    }  
    .swiper-pagination-bullet-active {  
        width: 15px;    
        background-color: #ea670c; /* 自定义激活状态的背景颜色 */  
    }
</style>
<style scoped>
    .Banner{
        max-height: 300px;
    }
    .Banner img {
        width: 100%;
        max-height: 300px;
        border-radius: 10px;
    }
    @media only screen and (max-width: 550px){
        .Banner img {
            min-height: 160px;
        }
    }
</style>